import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {Loner} from "../../../Loner";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {gsap} from "gsap";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {LonerSound} from "../../../sound/LonerSound";
import {LonerGameMode} from "../../../server/LonerGameMode";
import {MAIN_FG_ANIMATION_NAMES} from "../../general/LonerForegroundView";

export class LonerPinTheWinIntroView extends PIXI.Container implements StageLayer {
    private _button: ContinueButton;
    private _clickCallBack: Function;

    constructor() {
        super();
        this.name = "LonerPinTheWinIntroView";
        this.init();
        this.onResize();
    }

    public showIntro(finishCallback: Function): gsap.core.Timeline {
        this._clickCallBack = finishCallback;
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            Loner.xBetView.pauseRedDotBlinkTL();
            Loner.logoView.hide();
            Loner.tvMessageView.hide();
            Loner.foregroundView.setMode(LonerGameMode.FEATURE_PIN_THE_WIN);
            Loner.soundPlayer.fadeMusic(1, 0, 0.001);
            Loner.soundPlayer.playSound(LonerSound.PTW_INTRO_LOOP, 1, Number.MAX_VALUE);
            this.visible = true;
            this._button.visible = true;
        });
        tl.add(() => {
            this._button.enable(true);
        })
        return tl;
    }

    public onResize(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;

        //Copied from Launcher/GameIntroView, so we get consistent placement of buttons
        if (NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
        } else {
            const centerBottom: number = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(360, centerBottom - 80);
        }
    }

    private createButton(): ContinueButton {
        const button:ContinueButton = new ContinueButton();
        button.addClickCallback(() => this.onButtonClick());
        button.pivot.set(button.width * 0.5, button.height * 0.5);
        button.enable(false);
        button.visible = false;
        button.alpha = 0;
        return button;
    }
    public handleRestore():void{
        Loner.soundPlayer.switchMusic(LonerGameMode.FEATURE_PIN_THE_WIN);
        Loner.soundPlayer.fadeMusic(0, 1, 0.001);
        Loner.allReelView.visible = false;
        Loner.allReelView.resetAllReels();
        Loner.foregroundView.endForegroundSwitchTL();
        Loner.foregroundView.clearAnimationTrack(0);
        Loner.xBetView.pauseRedDotBlinkTL();
        Loner.logoView.hide();
        Loner.tvMessageView.hide();
        Loner.pinTheWinMainView.visible = true;
    }

    private onButtonClick(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        this._button.enable(false);
        Loner.soundPlayer.switchMusic(LonerGameMode.FEATURE_PIN_THE_WIN);
        Loner.soundPlayer.stopSound(LonerSound.PTW_INTRO_LOOP);
        Loner.soundPlayer.fadeMusic(0, 1, 0.001);
        Loner.soundPlayer.playSound(LonerSound.PTW_INTRO_CONTINUE_BTN);
        tl.add(() => {
                Loner.allReelView.visible = false;
                Loner.allReelView.resetAllReels();
            }
        );
        tl.add(() => {
            Loner.foregroundView.endForegroundSwitchTL();
            Loner.foregroundView.clearAnimationTrack(0);
            this.visible = false;
            Loner.pinTheWinMainView.visible = true;
            this._clickCallBack();
        });
        return tl;
    }

    private init(): void {
        this._button = this.createButton();
        this.visible = false;
        this.addChild(this._button);
    }

}